import React, { useEffect } from 'react'
import { Form } from 'antd';
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { api } from '../../../../../api/api';
import { LevelObj, ObjDB } from '../../../../../types/apiTypes';
import FormStatus from '../../../../../components/form/FormStatus/FormStatus';
import { useFormStatus } from '../../../../../utils/hooks/useFormStatus';
import { LevelFormFields } from '../../../../../types/formFieldTypes';
import EditPlaceholder from '../../../../../components/common/EditPlaceholder/EditPlaceholder';
import { clearLevelErrors, initialLevelFields, levelValidate } from '../../formData/LevelFormData';
import { getAntField } from '../../../../../utils/form';
import LevelFormInputs from '../LevelFormInputs/LevelFormInputs';
import { invalidateQueries } from '../../../../../utils/rest';
import { queryKeysLevel } from '../../../../../static/data/queryKeys';


type LevelEditFormProps = {
    editItem: ObjDB<LevelObj> | null
    setOpenedForm: React.Dispatch<React.SetStateAction<boolean>>
    setEditItem: React.Dispatch<React.SetStateAction<ObjDB<LevelObj> | null>>
}

const LevelEditForm: React.FC<React.PropsWithChildren<LevelEditFormProps>> = React.memo((props) => {
    const {
        editItem, setOpenedForm, setEditItem
    } = props

    const formStatus = useFormStatus()

    const {
        errors, values, touched,
        handleChange,
        submitForm, setValues, setErrors,
    } = useFormik<LevelFormFields>({
        initialValues: initialLevelFields,
        onSubmit: (values) => {
            mutate(values)
        },
        validate: levelValidate
    })

    const antField = getAntField<LevelFormFields>(values, errors, touched)

    const {
        mutate
    } = useMutation(
        async (values: LevelFormFields) => {
            if (editItem) return await api.levels.edit(values, editItem)
        },
        {
            mutationKey: 'level-edit',
            onSuccess() {
                invalidateQueries(queryKeysLevel[0])
                formStatus.setMessage('Данные успешно изменены')
                formStatus.setStatus('success')
                setTimeout(clearEditItem, 1000)
            },
            onError(err: Error) {
                console.error('ERROR', err)
                formStatus.setMessage(`Ошибка: ${err.message}`)
                formStatus.setStatus('error')
                setTimeout(clearEditItem, 5000)
            },
            onMutate() {
                formStatus.setMessage('Отправка данных')
                formStatus.setStatus('fetching')
            }
        }
    )

    const clearForm = () => {
        setValues(initialLevelFields)
        setErrors(clearLevelErrors)
    }

    const clearEditItem = () => {
        clearForm()
        setOpenedForm(false)
        setTimeout(() => {
            setEditItem(null)
            formStatus.reset()
        }, 300)
    }

    const resetChanges = () => {
        if (editItem) {
            const { id, ...values } = editItem
            setValues(values)
            setErrors(clearLevelErrors)
        }
    }

    useEffect(() => {
        if (editItem) return resetChanges()
        clearForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editItem])


    if (!editItem) return <EditPlaceholder />

    return (
        <Form
            fields={[antField('name')]}
        >
            {
                editItem &&
                <p className="uif-ant-form-title">
                    ID редактируемого объекта: <span>{editItem.id}</span>
                </p>
            }
            <LevelFormInputs
                handleChange={handleChange}
                resetChanges={resetChanges}
                submitForm={submitForm}
            />

            <FormStatus formStatus={formStatus} />
        </Form>
    )
})

export default LevelEditForm